import Slider4 from './Slider4'
export default Slider4
